import React, { Fragment } from "react";

export default () => {
  const ageData = [
    { option: "Fawn", value: "FAWN" },
    { option: "1 - 1.5", value: "1 - 1.5" },
    { option: "2 - 2.5", value: "2 - 2.5" },
    { option: "3 - 3.5", value: "3 - 3.5" },
    { option: "4 - 4.5", value: "4 - 4.5" },
    { option: "5 - 5.5 +", value: "5 - 5.5 +" },
    { option: "Adult", value: "ADULT" }
  ];

  return (
    <Fragment>
      <option />
      {ageData.map((l, i) => (
        <option key={i} value={l.value}>
          {l.option}
        </option>
      ))}
    </Fragment>
  );
};



// WEBPACK FOOTER //
// ./src/components/wizardSection/renderAgeOptions.jsx